import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null); // null = checking, false = anon, obj = logged
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("gc_customer_token");
    if (!token) {
      setCustomer(false);
      setReady(true);
      return;
    }
    try {
      const r = await api.get("/customer/auth/me");
      setCustomer(r.data);
    } catch {
      localStorage.removeItem("gc_customer_token");
      setCustomer(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth callback, let AuthCallback handle it first.
    if (window.location.hash?.includes("session_id=")) {
      setReady(true);
      return;
    }
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/customer/auth/login", { email, password });
    localStorage.setItem("gc_customer_token", data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const register = async (payload) => {
    const { data } = await api.post("/customer/auth/register", payload);
    localStorage.setItem("gc_customer_token", data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const completeGoogle = async (sessionId) => {
    const { data } = await api.post("/customer/auth/session-data", {}, { headers: { "X-Session-ID": sessionId } });
    localStorage.setItem("gc_customer_token", data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const logout = async () => {
    try { await api.post("/customer/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("gc_customer_token");
    setCustomer(false);
  };

  return (
    <Ctx.Provider value={{ customer, ready, login, register, completeGoogle, logout, refresh }}>
      {children}
    </Ctx.Provider>
  );
}

export const useCustomerAuth = () => useContext(Ctx);
